import { render, staticRenderFns } from "./RecoverPasswordByMailView.vue?vue&type=template&id=0e2cfaf6"
import script from "./RecoverPasswordByMailView.vue?vue&type=script&lang=ts"
export * from "./RecoverPasswordByMailView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports